import React, { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { TextInput } from 'is24-corecss'

import { LinkState } from './MultimediaLinksManager'

export interface MultimediaLinksManagerProps extends LinkState {
  onChange: (property: string, value: string) => void
  onBlur: (property: string, value: string) => void
}

const MultimediaAddLink: React.FC<MultimediaLinksManagerProps> = ({
  isValidLinkAddress,
  isValidLinkTitle,
  linkAddress,
  linkTitle,
  onChange,
  onBlur,
}) => {
  const { t } = useTranslation()

  const doChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>, property: string) =>
    onChange(property, value)
  const doBlur = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>, property: string) =>
    onBlur(property, value)

  return (
    <>
      <div className='one-whole margin-top-l'>
        <TextInput
          id='link-address'
          valid={isValidLinkAddress}
          errorMessage={t('validation.multimediaLinkValidationError', 'Invalid or missing characters')}
          placeholder={t('wizard.screen.multimedia.linksManager.linkAddressPlaceholder', 'e.g. www.my-web-address.com')}
          label={<span>{t('wizard.screen.multimedia.linksManager.linkAddressLabel', 'Link (Internet address)')}</span>}
          value={linkAddress}
          type='text'
          onChange={(value: ChangeEvent<HTMLInputElement>) => doChange(value, 'linkAddress')}
          onBlur={(value: ChangeEvent<HTMLInputElement>) => doBlur(value, 'linkAddress')}
        />
      </div>
      <div className='one-whole margin-top-l'>
        <TextInput
          id='link-title'
          valid={isValidLinkTitle}
          errorMessage={
            isValidLinkTitle
              ? undefined
              : t('validation.multimediaLinkValidationError', 'Invalid or missing characters')
          }
          placeholder={t('wizard.screen.multimedia.linksManager.linkTitlePlaceholder', 'e.g. Homepage')}
          label={<span>{t('wizard.screen.multimedia.linksManager.linkTitleLabel', 'Title')}</span>}
          value={linkTitle}
          type='text'
          onChange={(value: ChangeEvent<HTMLInputElement>) => doChange(value, 'linkTitle')}
          onBlur={(value: ChangeEvent<HTMLInputElement>) => doBlur(value, 'linkTitle')}
        />
      </div>
    </>
  )
}

export default MultimediaAddLink
